import PurchaseOrder from '../Components/Purchase/PurchaseOrder'

function PurchaseOrderPage() {
  return (
    <>
    <PurchaseOrder/>
    </>
  )
}

export default PurchaseOrderPage